import { render } from 'preact';

// Глобальные стили — порядок важен: tokens → base → layout → mobile.
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@/styles/tokens.css';
import '@/styles/base.css';
import '@/styles/layout.css';
import '@/styles/mobile.css';

import { App } from '@/App.jsx';
import { initRouter } from '@/router';
import { initErrorReporter } from '@/lib/error-reporter';
import { initPWA } from '@/pwa/register-sw';
import { initInstall } from '@/pwa/install';

initRouter();
initErrorReporter();
initPWA();
initInstall();

const rootEl = document.getElementById('app');
if (rootEl) {
  render(<App />, rootEl);
}
